import { useCallback } from "react";
import { VideoEvent } from "../../../lib/analytics/utils";
import { useOrcaAdsContext } from "../../contexts/OrcaAdsContext";

export const useHandleVideoEnd = ({
  autoplayState,
  sendAnalyticsEvent,
  resetVideoState,
  willPlaythrough,
  switchToNextVideo,
  onVideoEnded,
  hasNextRecVideo,
  isFullscreen,
  isNativeIOSPlayer,
  setIsFullscreen
}) => {
  const { shouldShowAds } = useOrcaAdsContext();
  const handleVideoEnd = useCallback(() => {
    if (!autoplayState.isLooping) sendAnalyticsEvent(VideoEvent.COMPLETE);

    resetVideoState(willPlaythrough && hasNextRecVideo);

    if (willPlaythrough) {
      if (isNativeIOSPlayer && isFullscreen && shouldShowAds) {
        setIsFullscreen(false);
      }
      switchToNextVideo();
    }

    onVideoEnded();
  }, [
    autoplayState.isLooping,
    sendAnalyticsEvent,
    resetVideoState,
    willPlaythrough,
    switchToNextVideo,
    onVideoEnded,
    hasNextRecVideo,
    isFullscreen,
    isNativeIOSPlayer,
    setIsFullscreen,
    shouldShowAds
  ]);

  return handleVideoEnd;
};
